var _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F9D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4016 8.57569C25.5563 6.57569 28.4431 6.57568 29.5978 8.57568L44.2549 33.9625C45.4096 35.9625 43.9662 38.4625 41.6568 38.4625H12.3427C10.0333 38.4625 8.58988 35.9625 9.74458 33.9625L24.4016 8.57569Z",
    fill: "#EB4D4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.4717,
    y: 15.2832,
    width: 3.0566,
    height: 14.2642,
    rx: 1.5283,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4717,
    y: 31.585,
    width: 3.0566,
    height: 3.0566,
    rx: 1.5283,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon-warn.63b2074a7b60174403141938351a7f19.svg";
export { ForwardRef as ReactComponent };